import {Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {InternalDocummentID, SMMDocumment, SMMDocummentAudit} from "../document-types";
import {formatDate, NgIf, NgSwitch, NgSwitchCase} from "@angular/common";
import {
    AcordPacientInformatTemplateSibV2
} from "../acord-pacient-informat/acord-pacient-informat-sib-v2/template/acord-pacient-informat-template-sib-v2.component";
import {ActivatedRoute, RouterLink} from "@angular/router";
import {DocummentsService} from "../documents.service";
import {BasicTemplate} from "../base-behaviour/template";
import {BasicInfoTemplate} from "../basic-info/template/basic.patient.info.template";
import {MatDivider} from "@angular/material/divider";
import {AuditComponent} from "../../../shared/components/audit/audit.component";
import {DateTimeService} from "../../../core/services/date.time.service";
import {fuseAnimations} from "../../../../@fuse/animations";
import {MatIcon} from "@angular/material/icon";
import {MatPrefix} from "@angular/material/form-field";
import {MatButton} from "@angular/material/button";
import {MatTooltip} from "@angular/material/tooltip";
import {TranslocoPipe} from "@ngneat/transloco";
import {Location} from '@angular/common';
import {PermissionsService} from "../../../core/services/permissions.service";
import {
    BuletinInformativTemplateSibV2
} from "../chest-eval-gen-stare-sanatate/buletin-informativ-sib-v2/template/buletin-informativ-template-sib-v1.component";
import {GdprSibV1Template} from "../GDPR-consimtamant/gdpr-sib-v1/template/gdpr-sib-v1.component";



@Component({
    selector: 'template-doc-wrapper',
    templateUrl: './template.wrapper.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    animations: fuseAnimations,
    imports: [
        NgIf,
        NgSwitch,
        AcordPacientInformatTemplateSibV2,
        NgSwitchCase,
        BasicInfoTemplate,
        MatDivider,
        AuditComponent,
        MatIcon,
        MatPrefix,
        MatButton,
        MatTooltip,
        TranslocoPipe,
        RouterLink,
        AcordPacientInformatTemplateSibV2,
        BuletinInformativTemplateSibV2,
        GdprSibV1Template
    ]
})
export class TemplateWizzardComponent implements OnInit
{
    @ViewChild('printableDoc') printableDoc!: ElementRef;
    internalDocID:InternalDocummentID;
    docID:string;
    flowID:string;

    document:SMMDocumment;
    flow:SMMDocummentAudit;

    /**
     * Constructor
     */
    constructor(
        private route: ActivatedRoute,
        private readonly doc_service:DocummentsService,
        private readonly _dtsrv:DateTimeService,
        private readonly _location: Location,
        private readonly permissionService: PermissionsService,
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------


    /**
     * On init
     */
    ngOnInit(): void
    {
        this.route.queryParams.subscribe(params => {
            this.internalDocID = params['docID'];
            this.docID = params['doc'];
            this.flowID = params['flow'];

            if(this.flowID != 'BASIC_INFO_FLOW'){
                this.doc_service.getDocFromBE(this.docID).subscribe(value => {
                    this.document = value;
                })

                this.doc_service.getFlowFromBE(this.flowID).subscribe(value => {
                    this.flow = value;
                })
            }
        });
    }

    protected readonly DocummentID = InternalDocummentID;

    printDoc() {
        const htmlData = this.printableDoc.nativeElement.innerHTML;
        //this.doc_service.printDocumment(htmlData);
        this.doc_service.printDiv("printableDoc")
    }

    getDateString(userCompletionTime: []) {
        if(userCompletionTime?.length > 0){
            const date: Date = this._dtsrv.getDateAndTimeFromBEInDateObject(userCompletionTime);
            if(date){
                return formatDate(date,"dd MMM yyyy HH:mm", "ro-RO");
            }
        }
        return "-"
    }

    getNotificationActivated() {
        return this.flow?.notifyUserOnCompletion? 'ACTIVATA' : 'DEZACTIVATA';
    }

    backClicked() {
        this._location.back();
    }

    canPrint() {
        return !this.permissionService.isVisitor();
    }
}
